import { Outlet } from "react-router-dom"
import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { NarrowNavItems, NarrowNavItemsProps } from "./NarrowNavItems"
import { PropsWithChildren } from "react"
import { tailwindPalette } from "../../modules/theme/tailwindPalette"

const useStyles = makeStyles()(() => ({
    container: {
        backgroundColor: tailwindPalette.blue[50],
        minHeight: "100vh",
        position: "relative",
    },
    mainContent: {
        display: "flex",
        width: "100%",
    },
    pageContainer: {
        padding: "1rem 2rem",
        width: "100%",
        marginLeft: "7rem",
    },
}))

export function NarrowNavLayout({ navItems, children }: PropsWithChildren<NarrowNavItemsProps>) {
    const { classes } = useStyles()

    return (
        <Box className={classes.container}>
            {children}
            <Box className={classes.mainContent}>
                <NarrowNavItems navItems={navItems} />
                <Box className={classes.pageContainer}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    )
}
